import { Grid } from '@material-ui/core'
import { Button } from 'react-admin'
import { useStyles } from '../styles'

export const OpenParent = ({ setOpenResolutionId, setIsChanged, ...props }) => {
  const record = { props }
  const classes = useStyles()

  if (!record.parent_id) return null

  const reload = () => {
    setOpenResolutionId(record.parent_id)
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }

  return (
    <Grid item xs={12}>
      <Button
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label="Voir la résolution parente"
        onClick={reload}
      />
    </Grid>
  )
}
export default OpenParent
